import Header from "../../Header";
import { useParams } from "react-router-dom";
import React, { useEffect, useState} from "react";
import { User, ValidationErrors } from "../../../types/admin";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { AxiosError } from 'axios';
import UserComponent from "../../../Components/admin/UserComponent";
import { AdminApi } from "../../../Api/AdminApi";
import { useAdmin } from "../../../Utils/AdminContext";

function CreateUser() {
  const { instance, accounts } = useMsal();
  const [ user, setUser] = useState<User>();
  const [ successMessage, setSuccessMessage ] = useState<string>("");
  const [errors, setErrors] = useState<ValidationErrors>({});
  const api = new AdminApi(accounts[0], instance);
  const navigate = useNavigate();
  
    const { isAdmin, setIsAdmin } = useAdmin();
    useEffect(() => {
      if (isAdmin === false) {
        navigate('/'); 
      }
    }, [isAdmin, navigate]);

  useEffect(() => {
    const newUser: User = {
        id: "",
        azureAdId : "",
        name: null,
        email: null,
        isAdmin: false
    }
    setUser(newUser);
  }, []);

  const handleInputChange = (field: keyof User) => (e: React.ChangeEvent<HTMLInputElement>) => {
    if (user) {
      setUser({
        ...user,
        [field]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
      });
    }
  };

  const handleSubmit = async (user : User) => {
    setErrors({});
    setSuccessMessage("");
    try{
      var result = await api.createUser(user);
      if (result === "success") {
        setSuccessMessage("User has been successfully created");
      }
      navigate("/admin/")

    }catch(error)
    {
      if (error instanceof AxiosError &&error.response?.status === 400) {
        setErrors(error.response.data.errors);
      }else{
        navigate("/")
      }
    }
  }
  return (
    <>
      <Header projectName="" loaded={false}isAdmin={true} />
      {user === undefined ? null :
        <div className="project-container">
          <UserComponent 
            onChange={handleInputChange} 
            handleSubmit={() =>handleSubmit(user)} 
            user={user}
            errors={errors}
            successMessage={successMessage}
            isUserCreation={true}/>
        </div>
      } 
    </>
  );
}

export default CreateUser;